// Google Analytics 4 helpers for the Tradies Directory SPA.
// gtag is loaded via /public/index.html with send_page_view: false.

const GA_ID = 'G-F586JRLJL4';

const gtag = (...args) => {
  if (typeof window !== 'undefined' && typeof window.gtag === 'function') {
    window.gtag(...args);
  }
};

export const trackPageView = (path, title) => {
  gtag('event', 'page_view', {
    page_path: path,
    page_title: title || document.title,
    page_location: window.location.href,
    send_to: GA_ID,
  });
};

export const trackEvent = (eventName, params = {}) => {
  gtag('event', eventName, { ...params, send_to: GA_ID });
};
